import React, { useState } from 'react';
import classes from './style.module.scss';
import Icon from '~/app/common/Icon';

export interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

export type CollapsibleSectionComponent = React.FC<CollapsibleSectionProps>;

const CollapsibleSection: CollapsibleSectionComponent = ({
  title,
  children,
  defaultExpanded,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded ?? false);

  return (
    <div className={classes['section']}>
      <div
        role="button"
        tabIndex={0}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((prev) => !prev)}
        className={classes['external-switch']}
      >
        {title}
        {isExpanded ? (
          <Icon name="keyboard_arrow_up" />
        ) : (
          <Icon name="keyboard_arrow_down" />
        )}
      </div>
      {isExpanded && children}
    </div>
  );
};

export default CollapsibleSection;
